"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_COMMUN = exports.FR_COMMUN = void 0;
/**
 * Espace « commun » du catalogue ICU — F-LNG-01, F-LNG-04 (PP-05).
 *
 * Un fichier par espace de noms, pour qu'une surface n'embarque que les siens :
 * le catalogue complet pèse ~380 Ko et chaque application n'en lit qu'une part.
 * Les deux langues vivent côte à côte pour que l'anglais reste livré avec le français.
 */
exports.FR_COMMUN = {
    'commun.nom_application': 'qanbio',
    'commun.marque_point': '.',
    'commun.langue.francais': 'Français',
    'commun.langue.anglais': 'English',
    'commun.langue.code_francais': 'FR',
    'commun.langue.code_anglais': 'EN',
    'commun.action.reessayer': 'Réessayer',
    'commun.action.continuer': 'Continuer',
    'commun.action.enregistrer': 'Enregistrer',
    'commun.action.deconnexion': 'Se déconnecter',
    'commun.action.supprimer_compte': 'Supprimer mon compte',
    'commun.etat.chargement': 'Chargement…',
    'commun.etat.connexion_service': 'Connexion au service…',
    'commun.erreur.demarrage_service': 'Le service met du temps à répondre. Réessayez dans un instant.',
    'commun.erreur.reseau': 'La connexion a échoué. Vérifiez le réseau puis réessayez.',
    'commun.erreur.service': 'Le service est momentanément indisponible. Réessayez dans un instant.',
    'commun.erreur.configuration': "L'adresse de l'API manque dans la configuration de l'application.",
    'commun.mise_a_jour.etiquette_facultative': 'Recommandée',
    'commun.mise_a_jour.etiquette_obligatoire': 'Requise',
    'commun.mise_a_jour.titre': 'Une nouvelle version est disponible',
    'commun.mise_a_jour.description_facultative': 'Mettez l’application à jour pour profiter des dernières améliorations.',
    'commun.mise_a_jour.description_obligatoire': 'Cette version n’est plus compatible avec le service. Installez la mise à jour pour continuer.',
    'commun.mise_a_jour.version': 'Nouvelle version :',
    'commun.mise_a_jour.action': 'Mettre à jour',
    'commun.mise_a_jour.plus_tard': 'Plus tard',
    'commun.action.retour': 'Retour',
    'commun.apropos.titre': 'À propos',
    'commun.apropos.version': 'Version',
    'commun.apropos.version_inconnue': 'Indisponible',
    'commun.apropos.cgu': "Conditions générales d'utilisation",
    'commun.apropos.confidentialite': 'Politique de confidentialité',
    'commun.apropos.contact': 'Contact',
    'commun.apropos.contact_adresse': 'contact@qanbio.com',
    'commun.notifications.titre': 'Notifications',
    'commun.notifications.activees': 'Activées',
    'commun.notifications.desactivees': 'Désactivées',
    'commun.position.titre': 'Position',
    'commun.position.activee': 'Activée',
    'commun.position.desactivee': 'Désactivée',
    'commun.photos.titre': 'Photothèque',
    'commun.photos.activee': 'Activée',
    'commun.photos.desactivee': 'Désactivée',
    'commun.message.reponse.jarrive': 'J’arrive',
    'commun.message.reponse.un_instant': 'Un instant, j’arrive',
    'commun.message.reponse.au_point_de_rendez_vous': 'Je suis au point de rendez-vous',
    'commun.message.reponse.je_vous_vois': 'Je vous vois',
    'commun.message.reponse.ou_etes_vous': 'Où êtes-vous ?',
    'commun.message.reponse.je_ne_vois_pas_la_voiture': 'Je ne vois pas la voiture',
    'commun.message.reponse.arrive_bientot': 'J’arrive dans quelques minutes',
    'commun.message.reponse.bloque_circulation': 'Je suis bloqué dans la circulation',
    'commun.message.reponse.je_suis_devant': 'Je suis devant',
    'commun.message.reponse.je_vous_attends': 'Je vous attends',
    'commun.message.reponse.je_ne_vous_vois_pas': 'Je ne vous vois pas',
};
exports.EN_COMMUN = {
    'commun.nom_application': 'qanbio',
    'commun.marque_point': '.',
    'commun.langue.francais': 'Français',
    'commun.langue.anglais': 'English',
    'commun.langue.code_francais': 'FR',
    'commun.langue.code_anglais': 'EN',
    'commun.action.reessayer': 'Try again',
    'commun.action.continuer': 'Continue',
    'commun.action.enregistrer': 'Save',
    'commun.action.deconnexion': 'Sign out',
    'commun.action.supprimer_compte': 'Delete my account',
    'commun.etat.chargement': 'Loading…',
    'commun.etat.connexion_service': 'Connecting to the service…',
    'commun.erreur.demarrage_service': 'The service is taking a while to respond. Try again in a moment.',
    'commun.erreur.reseau': 'Connection failed. Check your network and try again.',
    'commun.erreur.service': 'The service is temporarily unavailable. Try again in a moment.',
    'commun.erreur.configuration': 'The API address is missing from the app configuration.',
    'commun.mise_a_jour.etiquette_facultative': 'Recommended',
    'commun.mise_a_jour.etiquette_obligatoire': 'Required',
    'commun.mise_a_jour.titre': 'A new version is available',
    'commun.mise_a_jour.description_facultative': 'Update the app to benefit from the latest improvements.',
    'commun.mise_a_jour.description_obligatoire': 'This version is no longer compatible with the service. Install the update to continue.',
    'commun.mise_a_jour.version': 'New version:',
    'commun.mise_a_jour.action': 'Update',
    'commun.mise_a_jour.plus_tard': 'Later',
    'commun.action.retour': 'Back',
    'commun.apropos.titre': 'About',
    'commun.apropos.version': 'Version',
    'commun.apropos.version_inconnue': 'Unavailable',
    'commun.apropos.cgu': 'Terms of use',
    'commun.apropos.confidentialite': 'Privacy policy',
    'commun.apropos.contact': 'Contact',
    'commun.apropos.contact_adresse': 'contact@qanbio.com',
    'commun.notifications.titre': 'Notifications',
    'commun.notifications.activees': 'Enabled',
    'commun.notifications.desactivees': 'Disabled',
    'commun.position.titre': 'Location',
    'commun.position.activee': 'Enabled',
    'commun.position.desactivee': 'Disabled',
    'commun.photos.titre': 'Photo library',
    'commun.photos.activee': 'Enabled',
    'commun.photos.desactivee': 'Disabled',
    'commun.message.reponse.jarrive': 'I’m on my way',
    'commun.message.reponse.un_instant': 'One moment, I’m coming',
    'commun.message.reponse.au_point_de_rendez_vous': 'I’m at the meeting point',
    'commun.message.reponse.je_vous_vois': 'I can see you',
    'commun.message.reponse.ou_etes_vous': 'Where are you?',
    'commun.message.reponse.je_ne_vois_pas_la_voiture': 'I can’t see the car',
    'commun.message.reponse.arrive_bientot': 'I’ll be there in a few minutes',
    'commun.message.reponse.bloque_circulation': 'I’m stuck in traffic',
    'commun.message.reponse.je_suis_devant': 'I’m outside',
    'commun.message.reponse.je_vous_attends': 'I’m waiting for you',
    'commun.message.reponse.je_ne_vous_vois_pas': 'I can’t see you',
};
//# sourceMappingURL=commun.js.map